let bCobrowseLoaded = false; /**WEBMESS-540: boolean variable to determine if the Cobrowse plugin is already initialized or not, when the Genesys.init command is getting called without page refresh*/

function initCobrowse(config, GenesysJS) {
  const cobrowse = config.deploymentConfig.cobrowse||{};

  if (cobrowse.enabled === true) {
    if (!bCobrowseLoaded) {
      bCobrowseLoaded = true;
      GenesysJS.log('Cobrowse enabled. Loading CobrowseService plugin.');
      Genesys('loadPlugin', 'CobrowseService');
    }
  }
}

export default initCobrowse;
